import { Controller } from "@hotwired/stimulus";

// Pack picker: one CTA below the list, retargeted at whichever option is
// selected. The CTA is rendered pointing at the mega pack, so it still buys
// something with JS off; this only keeps it in step with the selection.
export default class extends Controller {
  static targets = ["option", "cta"];

  select(event) {
    const option = event.currentTarget;
    this.optionTargets.forEach((other) => other.classList.toggle("is-selected", other === option));
    const radio = option.querySelector("input[type=radio]");
    if (radio) radio.checked = true;
    if (!this.hasCtaTarget) return;
    const title = option.querySelector(".packs-option-title")?.textContent.trim();
    if (title) this.ctaTarget.textContent = this.ctaTarget.dataset.label.replace("%{pack}", title);
    this.ctaTarget.href = option.dataset.checkoutUrl || "#pakiety";
  }
}
